import React from "react";
import PropTypes from "prop-types";
import RohRegion from "../../../../../models/RohRegion";
import getBaseLen from "../../../helpers/getBaseLen";

function RohTitle({ item, actions }) {
  const typeCl = "tooltip-label tw-w-20 tw-pb-0";

  return item ? (
    <div className="tw-text-sm">
      <div className="tooltip-header border-normal">
        <div className="tooltip-title">
          {item.region.chromosome.name}:{item.region.x0.toLocaleString()}..
          {item.region.x1.toLocaleString()}
        </div>
        <div className="tw-w-24" />
        <div className="tw-w-4">{actions}</div>
      </div>
      <div className="tooltip-row">
        <div className={typeCl}>Start</div>
        <div>
          {item.region.chromosome.name}:{item.region.x0.toLocaleString()}
        </div>
      </div>
      <div className="tooltip-row">
        <div className={typeCl}>End</div>
        <div>
          {item.region.chromosome.name}:{item.region.x1.toLocaleString()}
        </div>
      </div>
      <div className="tooltip-row">
        <div className={typeCl}>Length</div>
        <div>{getBaseLen(item.region.size)}</div>
      </div>
    </div>
  ) : null;
}

RohTitle.propTypes = {
  item: PropTypes.instanceOf(RohRegion).isRequired,
  actions: PropTypes.node,
};

RohTitle.defaultProps = {
  actions: null,
};

export default RohTitle;
